var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        no: "dialog",
        visible: _vm.innerVisible,
        title: _vm.$t("queryJob.installationInstructions"),
        width: "300px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        { attrs: { "label-width": "0" } },
        [
          _c(
            "el-form-item",
            [
              _c(
                "el-checkbox",
                {
                  attrs: { no: "takePhotos" },
                  model: {
                    value: _vm.takePhotos,
                    callback: function($$v) {
                      _vm.takePhotos = $$v
                    },
                    expression: "takePhotos"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("queryJob.whetherTakePhotos")))]
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c("el-input", {
                attrs: { no: "notes", type: "textarea", rows: 5 },
                model: {
                  value: _vm.notes,
                  callback: function($$v) {
                    _vm.notes = $$v
                  },
                  expression: "notes"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { no: "Confirm", type: "primary" },
              on: { click: _vm.clickHandler }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "Cancel" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("Message.Cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }